module.exports = __webpack_public_path__ + "img/telephone-for-home.09a548d9.png";